module.exports = __webpack_public_path__ + "img/img8.3e4dd84e.png";